import { render } from "./IconRankingOther.vue?vue&type=template&id=5b209d28&scoped=true"
import script from "./IconRankingOther.vue?vue&type=script&lang=js"
export * from "./IconRankingOther.vue?vue&type=script&lang=js"

import "./IconRankingOther.vue?vue&type=style&index=0&id=5b209d28&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b209d28"]])

export default __exports__